import { render, staticRenderFns } from "./MenuUserWidget.vue?vue&type=template&id=3618a13c&scoped=true"
import script from "./MenuUserWidget.vue?vue&type=script&lang=js"
export * from "./MenuUserWidget.vue?vue&type=script&lang=js"
import style0 from "./MenuUserWidget.vue?vue&type=style&index=0&id=3618a13c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618a13c",
  null
  
)

export default component.exports